import { render } from "./PayerRow.vue?vue&type=template&id=60770cc0&ts=true"
import script from "./PayerRow.ts?vue&type=script&lang=ts&external"
export * from "./PayerRow.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__